module.exports = __webpack_public_path__ + "img/sala1.24172109.jpg";